export default __webpack_public_path__ + "static/media/Group 4066.d4a693d6.png";